import { useNovel } from '@/context/novel-context';
import { useFirebase } from '@/firebase';
import type { ArcDetails } from '@/lib/types';
import { useEffect, useMemo, useState } from 'react';

export function useArcDetails(arcId: string | undefined) {
  const { backend } = useFirebase();
  const { novel } = useNovel();

  const [data, setData] = useState<ArcDetails | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(!!(novel && arcId));
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!novel.id || !arcId) {
      setData(null);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    const unsubscribe = backend.narrative.subscribeArcDetails(
      novel.ownerId,
      novel.id,
      novel.storageLayout,
      arcId,
      (details) => {
        setData(details);
        setIsLoading(false);
      },
      (err) => {
        setError(err);
        setIsLoading(false);
      }
    );

    return () => unsubscribe();
  }, [backend, novel?.ownerId, novel?.id, arcId]);

  return useMemo(() => ({ data, isLoading, error }), [data, isLoading, error]);
}
